export const businessIntelligenceMarketAnalysis = {
  name: "Market Analysis |||| Market Analysis",
};

export const businessIntelligenceSales = {
  name: "Sales |||| Sales",
};

export const businessIntelligenceGeographicAnalysis = {
  name: "Geographic Analysis |||| Geographic Analysis",
};

export const businessIntelligencePipelineAnalysis = {
  name: "Pipeline Analysis |||| Pipeline Analysis",
};

export const businessIntelligenceIrt = {
  name: "IRT |||| IRT",
};
